import _ from 'lodash';

const state = {
  reservableEditState: null,
};

const actions = {
  // MutateReservableEditState lets a user mutate the reservableEditState by
  // passing a mutator function.
  MutateReservableEditState({ commit }, fn) {
    commit('MUTATE_EDIT_RESERVABLE_STATE', fn);
  },

  // ReservableEditReset resets the edit page state.
  ReservableEditReset({ commit }) {
    commit('RESET_EDIT_RESERVABLE_STATE');
  },

  // StoreReservableEditState commits an edit page state to the store by deep
  // copying passed state.
  StoreReservableEditState({ commit }, editState) {
    commit('SET_EDIT_RESERVABLE_STATE', _.cloneDeep(editState));
  },
};

const mutations = {
  // MUTATE_EDIT_RESERVABLE_STATE mutates the editor state with a mutation
  // function.
  MUTATE_EDIT_RESERVABLE_STATE(stateArg, fn) {
    fn(stateArg.reservableEditState);
  },

  // RESET_EDIT_RESERVABLE_STATE resets the editor state.
  RESET_EDIT_RESERVABLE_STATE(stateArg) {
    const stateCopy = stateArg;
    stateCopy.reservableEditState = null;
  },

  // SET_EDIT_RESERVABLE_STATE sets the editor state.
  SET_EDIT_RESERVABLE_STATE(stateArg, editState) {
    const stateCopy = stateArg;
    stateCopy.reservableEditState = editState;
  },
};

export default { actions, mutations, state };
